module.exports = __webpack_public_path__ + "../resources/images/illustration_search_file-853d05e5836f2aa863f045da08c3160c.svg";